const {
    accessToken = null,
    mapboxStyleUsername = null,
    mapboxStyleId = null,
} = window.MapboxConfig;
const mapboxgl = require('mapbox-gl');
const mapContainer = document.getElementById('location-map');

mapboxgl.accessToken = accessToken;

const initializeMap = () => {
    mapContainer.hidden = false;

    const locations = JSON.parse(window.map);
    const bounds = locations.reduce(
        (boundsObject, location) => boundsObject.extend([location.longitude, location.latitude]),
        new mapboxgl.LngLatBounds(),
    );

    const map = new mapboxgl.Map({
        container: mapContainer,
        center: [locations[0].longitude, locations[0].latitude],
        zoom: 12,
        bounds: locations.length > 1 ? bounds : false,
        fitBoundsOptions:
            locations.length > 1 ? { padding: window.innerWidth > 750 ? 140 : 50 } : false,
        style: `mapbox://styles/${mapboxStyleUsername}/${mapboxStyleId}`,
        cooperativeGestures: true,
    });

    map.on('load', async () => {
        const geojson = {
            type: 'FeatureCollection',
            features: locations.map(location => ({
                type: 'Feature',
                properties: {
                    title: location.title,
                    address: location.address,
                    url: location.url,
                    link_label: location.link_label,
                },
                geometry: {
                    type: 'Point',
                    coordinates: [location.longitude, location.latitude],
                },
            })),
        };

        for (const feature of geojson.features) {
            const marker = document.createElement('div');
            marker.className = 'map-marker';

            const coordinates = feature.geometry.coordinates.slice();
            const { title, address, url, link_label } = feature.properties;
            const popup = new mapboxgl.Popup({
                anchor: 'bottom',
            })
                .setOffset([0, window.innerWidth > 480 ? -60 : -45])
                .setHTML(
                    `<div class="map-popup" tabindex="0">
                        <div class="map-popup__text-wrapper">
                            <p class="map-popup__title">${title}</p>
                            <p class="map-popup__text">${address}</p>
                        </div>
                        <a class="map-popup__link" href="${url}" aria-label="${link_label}">
                            <div class="map-popup__icon-wrapper" aria-hidden="true">
                                <svg class="map-popup__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                    <!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License -
                                    https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                    <path d="M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64
                                    64l320 0c35.3 0 64-28.7 64-64l0-320zM361 273L249 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6
                                    0-33.9l71-71L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6
                                    0-33.9s24.6-9.4 33.9 0L361 239c9.4 9.4 9.4 24.6 0 33.9z"/></svg>
                            </div>
                        </a>
                    </div>`,
                );

            new mapboxgl.Marker(marker, {
                anchor: 'bottom',
            })
                .setLngLat(coordinates)
                .setPopup(popup)
                .addTo(map);
        }

        map.addControl(new mapboxgl.NavigationControl());
    });
};

const initializeMapAfterConsent = () => {
    const consentManager = window.klaro.getManager();

    if (consentManager.getConsent('mapbox')) {
        initializeMap();
    }

    consentManager.watch({
        update(obj, name, data) {
            if (name !== 'applyConsents') return;
            if (!obj.states.mapbox) return;
            initializeMap();
        },
    });
};

initializeMapAfterConsent();
